import { useState, useCallback } from 'react'
import { lumi } from '@/lib/lumi'

export interface TalentBankEntry {
  _id: string
  companyUserId: string
  companyName?: string
  collaboratorUserId: string
  collaboratorName?: string
  collaboratorEmail?: string
  collaboratorPhoto?: string
  classification?: string
  tags?: string[]
  notes?: string
  lastVacancyTitle?: string
  lastScore?: number
  creator?: string
  createdAt: string
  updatedAt: string
}

export function useTalentBank() {
  const [entries, setEntries] = useState<TalentBankEntry[]>([])
  const [loading, setLoading] = useState(false)

  const fetchByCompany = useCallback(async (companyUserId: string) => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.talent_bank.list({
        filter: { companyUserId },
        sort: { createdAt: -1 },
      })
      setEntries(list as TalentBankEntry[])
    } catch (e) {
      console.error('Error al cargar banco de talento:', e)
    } finally {
      setLoading(false)
    }
  }, [])

  const fetchAll = useCallback(async () => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.talent_bank.list({
        sort: { createdAt: -1 },
      })
      setEntries(list as TalentBankEntry[])
    } catch (e) {
      console.error('Error al cargar banco de talento:', e)
    } finally {
      setLoading(false)
    }
  }, [])

  const addEntry = useCallback(async (data: Partial<TalentBankEntry>) => {
    const now = new Date().toISOString()
    return lumi.entities.talent_bank.create({
      ...data,
      createdAt: now,
      updatedAt: now,
    })
  }, [])

  const updateEntry = useCallback(async (id: string, data: Partial<TalentBankEntry>) => {
    return lumi.entities.talent_bank.update(id, {
      ...data,
      updatedAt: new Date().toISOString(),
    })
  }, [])

  const removeEntry = useCallback(async (id: string) => {
    return lumi.entities.talent_bank.delete(id)
  }, [])

  return { entries, loading, fetchByCompany, fetchAll, addEntry, updateEntry, removeEntry }
}
